import React from 'react';
import Loadable from 'react-loadable';

import LoadingSpinner from '../../../../../components/loading_spinner/loading_spinner';

let Mic2019Component = false;
let Mic2018Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Mic2019Component = require('../mic_year_2019_page').default;
  // eslint-disable-next-line global-require
  Mic2018Component = require('../mic_year_2018_page').default;
}

export function micPage2019(store) {
  const routeConfig = {
    path: '/most-innovative-companies/2019/:sectors?/:sector?',
    component() {
      if (Mic2019Component) {
        return <Mic2019Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Mic2019Component ? Mic2019Component.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "MicYearPage2019" */ '../mic_year_2019_page').then(
        resp => {
          Mic2019Component = resp.default;
          routeConfig.loadData = Mic2019Component.loadData(store, '2017');
          return Mic2019Component;
        }
      );
    },
    chunk: 'MicYearPage2019'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

export function micPage2018(store) {
  const routeConfig = {
    path: '/most-innovative-companies/2018/:sectors?/:sector?',
    component() {
      if (Mic2018Component) {
        return <Mic2018Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Mic2018Component ? Mic2018Component.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "MicYearPage2018" */ '../mic_year_2018_page').then(
        resp => {
          Mic2018Component = resp.default;
          routeConfig.loadData = Mic2018Component.loadData(store);
          return Mic2018Component;
        }
      );
    },
    chunk: 'MicYearPage2018'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

let LegacyMICComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  LegacyMICComponent = require('../mic_year_page').default;
}

export function legacyMicPage(store) {
  const routeConfig = {
    path: '/most-innovative-companies/:year/:sectors?/:sector?',
    component() {
      if (LegacyMICComponent) {
        return <LegacyMICComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: LegacyMICComponent ? LegacyMICComponent.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "micYearPage" */ '../mic_year_page').then(
        resp => {
          LegacyMICComponent = resp.default;
          routeConfig.loadData = LegacyMICComponent.loadData(store);
          return LegacyMICComponent;
        }
      );
    },
    chunk: 'micYearPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
